var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-spinner',{attrs:{"label":"Spinner"}}),_c('div',{staticClass:"w-100"}),_c('p',[_vm._v(_vm._s(_vm.text)+"...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }